import Vue from 'vue';

export default id => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post(`/orders/return/${id}`)
      .then((response) => {
        resolve(response.data);
      })
      .catch((error) => {
        reject(error);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/order/returnOrder.js